// This file is auto-generated by @hey-api/openapi-ts

import type { RequestResult } from '../client';
import { client } from '../client.gen';
import type { Options } from '../sdk.gen';
import type { ExtractAddUsingPostData, ExtractAddUsingPostErrors, ExtractAddUsingPostResponses, ExtractHistoryUsingGetData, ExtractHistoryUsingGetErrors, ExtractHistoryUsingGetResponses } from '../types.gen';

export class DesktopExtractControllerService {
    /**
     * extractAdd
     */
    public static extractAddUsingPost<ThrowOnError extends boolean = false>(options?: Options<ExtractAddUsingPostData, ThrowOnError>): RequestResult<ExtractAddUsingPostResponses, ExtractAddUsingPostErrors, ThrowOnError> {
        return (options?.client ?? client).post<ExtractAddUsingPostResponses, ExtractAddUsingPostErrors, ThrowOnError>({
            url: '/v1/desktop/extract',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * extractHistory
     */
    public static extractHistoryUsingGet<ThrowOnError extends boolean = false>(options?: Options<ExtractHistoryUsingGetData, ThrowOnError>): RequestResult<ExtractHistoryUsingGetResponses, ExtractHistoryUsingGetErrors, ThrowOnError> {
        return (options?.client ?? client).get<ExtractHistoryUsingGetResponses, ExtractHistoryUsingGetErrors, ThrowOnError>({ url: '/v1/desktop/extract/history', ...options });
    }
}
